import { UniversalLoader } from '@/modules/common/components/universal-loader';
import { declineWord } from '@/modules/common/helpers/decline-word.helper';
import { deleteOffer } from '@/modules/offer/functions/delete-offer.function';
import {
  $specificTradeOffersGroup,
  $specificTradeOffersGroupLoadingStatus,
  fetchSpecificTradeOffersGroupDataFx,
} from '@/modules/offer/store/specific-trade.store';
import { useStore } from 'effector-react';
import { useSearchParams } from 'react-router-dom';
import { OfferContractItem } from './components/offer-contract-item';
import styles from './index.module.sass';

export const OffersTab = () => {
  const data = useStore($specificTradeOffersGroup);
  const loadingStatus = useStore($specificTradeOffersGroupLoadingStatus);
  const [params] = useSearchParams();
  const buyerable_id = Number(params.get('buyerable_id'));
  const buyerable_type = String(params.get('buyerable_type'));

  const deleteFoo = async (id: number, finallyFoo?: () => void) => {
    await deleteOffer(
      id,
      async () => {
        await fetchSpecificTradeOffersGroupDataFx({ buyerable_id, buyerable_type });
        finallyFoo && finallyFoo();
      }
    );
  };

  return (
    <div className={styles.root}>
      <div className={styles.topMetrics}>
        <span className={styles.count}>
          {declineWord(data?.offers?.length || 0, [
            'позиций',
            'позиция',
            'позиции',
            'позиций',
          ])}
        </span>
        <span className={styles.metric}>
          требуется миксование:{' '}
          <b>{data?.offers?.filter((item) => item.action === 'mix').length}</b>
        </span>
        <span className={styles.metric}>
          требуется осушение:{' '}
          <b>{data?.offers?.filter((item) => item.action === 'drain').length}</b>
        </span>
        <span className={styles.metric}>
          требуется увлажнение:{' '}
          <b>{data?.offers?.filter((item) => item.action === 'hydrate').length}</b>
        </span>
      </div>
      <div className={styles.itemsWrap}>
        {loadingStatus.loading || loadingStatus.error ? (
          <UniversalLoader error={loadingStatus.error} />
        ) : (
          data?.offers?.map((item) => (
            <OfferContractItem isLast={data.offers.length === 1} data={{...item, expiration_date: `${ item.expiration_date } UTC`}} deleteFoo={deleteFoo} />
          ))
        )}
      </div>
    </div>
  );
};
